<template lang="pug">
.pa-8
  v-row.mb-8
    template(v-for="analytic in analytics")
      v-col(cols="12" sm="6")
        stat-area-chart-card(:title="analytic.title" :count="analytic.count" :percentage="analytic.percentage" percentage-label="From avg daily sales")
  .mb-8
    .text-lg.font-semibold Rating breakdown
    apexchart(:options="options" :series="series" height="300" width="50%")
</template>

<script>
import StatAreaChartCard from './StatAreaChartCard.vue'

export default {
  name: 'ReviewInsights',
  components: { StatAreaChartCard },
  data: () => ({
    analytics: [
      { title: 'Clinic score', count: '4.5', percentage: 100 },
      { title: 'Number of ratings', count: '35'},
    ],
    series: [{
      data: [10, 8, 6, 7, 1]
    }],
    options: {
      chart: {
        type: 'bar',
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          horizontal: true,
        }
      },
      colors: ['#D6BBFB'],
      xaxis: {
        labels: {
          show: false
        },
        axisTicks: {
          show: false
        },
        categories: ['5.0', '4.0', '3.0', '2.0', '1.0'],
      },
      dataLabels: {
        enabled: false
      },
      grid: {
        show: false
      }
    }
  })
}
</script>